module.exports = __webpack_public_path__ + "img/404-sorry-kid.cdc6838c.png";